<template>
<article class="info-section elr-container-full">
  <div class="elr-row">
    <div class="elr-col-full">
        <div class="info-section-header">
            <h1 class="info-section-heading">Wishlist</h1>
            <p class="info-section-subheading" v-if="wishlist.visibility">Visibility: {{capitalize(wishlist.visibility)}}</p>
            <div class="button-holder">
                <button class="elr-button elr-button-primary" @click="togglePrivacy">Make Wishlist {{toggleLabel()}}</button>
                <router-link :to="`/wishlist/${wishlist.owner}/edit`" class="elr-button elr-button-primary">Edit Wishlist</router-link>
            </div>
            <p v-if="wishlist.notes" class="info-section-subheading">{{wishlist.notes}}</p>
            <ul class="list-stats elr-unstyled-list">
                <li>
                    <span class="elr-bold">Number of Ponies:</span> {{wishlist.item_count}}
                </li>
                <li v-if="wishlist.latest">
                    <span class="elr-bold">Last Pony Added:</span>
                    <router-link :to="`/pony/${wishlist.latest.id}`">{{wishlist.latest.name}}</router-link>
                </li>
            </ul>
            <div class="button-holder wishlist-filter">
                <h4 class="button-holder-heading">Filter by status:</h4>
                <button :key="status" v-for="status in status_items" @click="filter(status)" class="elr-button elr-button-primary" :class="{'button-disabled': hasStatus(status)}">{{capitalize(status)}}</button>
            </div>
        </div>
    </div>
  </div>
  <div class="elr-row">
    <div class="elr-col-full" v-if="items.length">
      <div class="list-item-grid">
        <wishlist-item-card @removedWishlistItem="removeCard" :key="item.id" v-for="item in items" :user="user" :item="item"></wishlist-item-card>
      </div>
    </div>
    <div class="elr-col-full" v-else>
      <p>There are no wishlist items</p>
    </div>
  </div>
</article>
</template>

<script>
import {findIndex} from 'lodash'
import axios from 'axios';
import { capitalize } from '../../utils/helpers';
import WishlistItemCard from '../../components/WishlistItemCard/WishlistItemCard';

export default {
  name: 'Wishlist',
  props: {
    username: {
      type: String
    },
    user: {
      type: Object,
      required: true
    },
    authenticated: {
      type: Boolean
    }
  },
  data() {
    return {
      errors: [],
      wishlist: {},
      items: {},
      status_items: {},
      currentStatus: 'wanted'
    };
  },
  components: {
    WishlistItemCard
  },
  mounted() {
    axios
      .get(`/wishlist/${this.username}/100`)
      .then(({ data }) => {
        this.wishlist = data.wishlist;
        this.items = data.items.data;
        this.status_items = data.status_items;
        // this.pagination = {
        //   prevUrl: data.items.prev_page_url,
        //   nextUrl: data.items.next_page_url,
        //   current: data.items.current_page,
        //   total: data.items.total,
        //   path: data.items.path,
        //   pageCount: data.items.last_page,
        //   firstUrl: `${data.items.path}?page=1`,
        //   lastUrl: `${data.items.path}?page=${data.items.last_page}`
        // };
      })
      .catch(e => {
        if (e && e.response) {
          this.errors.push(e.response.data);
        }
      });
  },
  methods: {
    capitalize,
    hasStatus(status) {
      return status !== this.currentStatus ? true : false;
    },
    filter(status) {
      if (status) {
        axios
          .get(`/wishlist/${this.username}/24/${status}`)
          .then(({ data }) => {
            this.items = data.items.data;
            this.pagination = {
              prevUrl: data.items.prev_page_url,
              nextUrl: data.items.next_page_url,
              current: data.items.current_page,
              total: data.items.total,
              path: data.items.path,
              pageCount: data.items.last_page,
              firstUrl: `${data.items.path}?page=1`,
              lastUrl: `${data.items.path}?page=${data.items.last_page}`
            };
          })
          .catch(e => {
            if (e && e.response) {
              this.errors.push(e.response.data);
            }
          });

        this.currentStatus = status;
      } else {
        axios
          .get(`/wishlist/${this.username}/24`)
          .then(({ data }) => {
            this.items = data.items.data;
            this.pagination = {
              prevUrl: data.items.prev_page_url,
              nextUrl: data.items.next_page_url,
              current: data.items.current_page,
              total: data.items.total,
              path: data.items.path,
              pageCount: data.items.last_page,
              firstUrl: `${data.items.path}?page=1`,
              lastUrl: `${data.items.path}?page=${data.items.last_page}`
            };
          })
          .catch(e => {
            if (e && e.response) {
              this.errors.push(e.response.data);
            }
          });

        this.currentStatus = 'unsold';
      }
    },
    toggleLabel() {
      return this.wishlist.visibility == 'Private' ? 'Public' : 'Private';
    },
    removeCard(payload) {
      let id = findIndex(this.items, o => o.id === payload);

      this.items.splice(id, 1);
    },
    fetchItems(payload) {
      let url = payload;

      axios.get(url).then(({ data }) => {
        this.items = data.items.data;
        this.pagination.prevUrl = data.items.prev_page_url;
        this.pagination.nextUrl = data.items.next_page_url;
        this.pagination.current = data.items.current_page;
      });

      window.scrollTo(0, 0);
    },
    togglePrivacy() {
      let visibility =
        this.wishlist.visibility == 'private' ? 'public' : 'private';
      let formData = {
        name: this.wishlist.name,
        notes: this.wishlist.notes,
        visibility
      };

      axios
        .put(`/wishlist/${this.owner}`, formData)
        .then(({ data }) => {
          this.errors = [];

          if (data.item) {
            this.wishlist.visibility = formData.visibility;
          } else {
            // this.resetForm()
            this.errors.push({
              error: ['Please try to update wishlists later']
            });
          }
        })
        .catch(e => {
          this.errors = [];

          if (e.response) {
            this.errors.push(e.response.data.errors);
          }
        });
    }
  },
  watch: {
    $route() {}
  }
};
</script>

<style scoped>
.button-holder {
  text-align: left;
  padding-top: 0;
}

.wishlist-filter button {
  margin: 0 10px 10px 0;
  max-width: 150px;
}
</style>
